/* tslint:disable */
/* eslint-disable */
/**
 * Sunshine Auction API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AdminAssignProductToGroupSale
 */
export interface AdminAssignProductToGroupSale {
    /**
     * 
     * @type {string}
     * @memberof AdminAssignProductToGroupSale
     */
    groupSaleId: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof AdminAssignProductToGroupSale
     */
    productIds: Array<string>;
}

export function AdminAssignProductToGroupSaleFromJSON(json: any): AdminAssignProductToGroupSale {
    return AdminAssignProductToGroupSaleFromJSONTyped(json, false);
}

export function AdminAssignProductToGroupSaleFromJSONTyped(json: any, ignoreDiscriminator: boolean): AdminAssignProductToGroupSale {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'groupSaleId': json['groupSaleId'],
        'productIds': json['productIds'],
    };
}

export function AdminAssignProductToGroupSaleToJSON(value?: AdminAssignProductToGroupSale | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'groupSaleId': value.groupSaleId,
        'productIds': value.productIds,
    };
}

